import type { InjectionKey } from 'vue';

import type { BrowserTimeService } from '@/service/BrowserTimeService';
import type { CarProgression } from '@/service/CarProgression';
import type { ContractProgression } from '@/service/ContractProgression';
import type { Greetings } from '@/service/greetings';
import type { LocationService } from '@/service/LocationService';
import type { MaintenanceProgression } from '@/service/MaintenanceProgression';

export const timeServiceKey: InjectionKey<BrowserTimeService> = Symbol('timeService');
export const greetingsServiceKey: InjectionKey<Greetings> = Symbol('greetingsService');
export const carProgressionServiceKey: InjectionKey<CarProgression> =
  Symbol('carProgressionService');
export const contractProgressionServiceKey: InjectionKey<ContractProgression> = Symbol(
  'contractProgressionService'
);
export const maintenanceProgressionServiceKey: InjectionKey<MaintenanceProgression> = Symbol(
  'maintenanceProgressionService'
);
export const locationServiceKey: InjectionKey<LocationService> = Symbol('locationService');
